import { post, postEwm, get,fetch ,fetchPost} from "./http";
let http = "";
let memberhttp="";
let spaceUpPc = "";
let spaceUpPcHttpTe = "";
let visitUrl = "";
//  http = "https://qfapi.topchainspace.com/";
//  spaceUpPc = "https://zgapi.topchainspace.com";
//  memberhttp = "https://qfapi2.topchainspace.com/";
console.log( 'process.env  ==== ' +JSON.stringify(process.env))
if (process.env.VUE_APP_APP_HOST) {
  // http = process.env.VUE_APP_APP_HOST;

  //  生产打包 npm run prod
   http = "https://qfapi.topchainspace.com/";
   memberhttp = "https://qfapi2.topchainspace.com/";
   spaceUpPc = "https://zgapi.topchainspace.com";
   visitUrl = 'https://h5.topchainspace.com'
    // 测试
  //  http = "https://rsttest.vanke.com/tcrstapi/";
  //  memberhttp = "https://rsttest.vanke.com/tcapi/";
  //  spaceUpPc = "https://rsttest.vanke.com/tc03";

  //  测试打包 npm run uat
  if(process.env.VUE_APP_APP_HOST.indexOf('uat-adminapi') > 0){
     http = "https://uat-adminapi.spaceup.com.cn/";
     memberhttp = "https://uat-adminapi.spaceup.com.cn/msapi/"; //https://qfapi2.topchainspace.com/ 缺少测试环境
     spaceUpPc = "https://uat-api.spaceup.com.cn";
     visitUrl = 'https://uat-admin.spaceup.com.cn'
  }else{
    // spaceUpPc = "https://api.spaceup.com.cn";
    // memberhttp = "https://mall-api.spaceup.com.cn/";

  }
} else {
  //  http = "https://qfapi.topchainspace.com/";
  //  memberhttp = "https://qfapi2.topchainspace.com/";
  //  spaceUpPc = "https://zgapi.topchainspace.com";
  //  visitUrl = 'https://h5.topchainspace.com
   console.log('in test')
   //  测试 npm run serve
   http = "https://uat-adminapi.spaceup.com.cn/";
   memberhttp = "https://uat-adminapi.spaceup.com.cn/msapi/"; //https://qfapi2.topchainspace.com/
   spaceUpPc = "https://uat-api.spaceup.com.cn";
   visitUrl = 'https://uat-admin.spaceup.com.cn'


  //  http = "https://rsttest.vanke.com/spaceuprstapi/";
  //  memberhttp = "https://rsttest.vanke.com/spaceupmemberapi/";
  //  spaceUpPc = "https://rsttest.vanke.com/spaceup03";
   spaceUpPcHttpTe = "http://api.skyline.test/syscfg";
}
export const serversHttp = http;
export const spaceUpPcHttp = spaceUpPc;
export const serversVisitUrl = visitUrl; //访客二维码h5地址
export const spaceUpPcHttpT = spaceUpPcHttpTe;
// 发送短信验证码
export const sendMsgCode = params => {
  return post(http + "servers.api/sendMsgApi/sendMsgCode", params);
};
// 登录接口
export const login = (params, header) => {
  return post(
    http + "servers.api/usersApi/wxAuthorizeBindUser",
    params,
    header
  );
};
// 公众号获取openId
export const getWapOpenId = (params, header) => {
  return post(http + "servers.api/wxLoginApi/getWapOpenId", params, header);
};
// 根据marketid获取用户信息
export const getUserMarketInfo = (params, header) => {
  return post(http + "servers.api/wxLoginApi/getUserMarketInfo", params, header);
};
//获取用户信息状态和会员冻结状态
export const getMemberUserInfo = (params, header) => {
  return post(http + "servers.api/wxLoginApi/getUserInfo", params, header)
};
// 会员隐私政策阅读
export const pointAgree = (params, header) => {
  return post(http + "servers.api/wxLoginApi/pointAgree", params, header)
}
// 获取活动列表
export const getActiveListByMarketId = (params, header) => {
  return post(
    http + "servers.api/activeApi/getActiveListByMarketId",
    params,
    header
  );
};
// 获取活动详情
export const getActiveDetailById = (params, header) => {
  return post(
    http + "servers.api/activeApi/getActiveDetailById",
    params,
    header
  );
};
// 活动报名
export const insertActiviteRegistration = (params, header) => {
  return post(
    http + "servers.api/activeRegistrationApi/insertActiviteRegistration",
    params,
    header
  );
};
// 活动核销
export const verificationCode = (params, header) => {
  return post(
    http + "servers.api/verificationApi/verificationCode",
    params,
    header
  );
};
// 订单支付详情
export const getUnpaidOrderInfoByOrderId = (params, header) => {
  return post(
    http + "servers.api/activeRegistrationApi/getUnpaidOrderInfoByOrderId",
    params,
    header
  );
};
// 获取有权限的公司列表（水电充值）
export const getPerssionCompanyList = (params, header) => {
  return post(
    http + "servers.api/usersApi/getPerssionCompanyList",
    params,
    header
  );
};
// 获取活动报名表字段
export const getRegDictFromByActId = (params, header) => {
  return post(
    http + "servers.api/regDictFormApi/getRegDictFromByActId",
    params,
    header
  );
};
// 首页轮播图
export const indexInfo = (params, header) => {
  return post(http + "servers.api/homeApi/indexInfo", params, header);
};
// 轮播图
export const getGroupResource = (params, header) => {
  return post(
    http + "member.api/mbGroupCmsApi/getGroupResource",
    params,
    header
  );
};
// // 根据兑换活动ID获取兑换活动详情
// export const getMbActiveById = (params, header) => {
//   return post(http + "member.api/mbActiveApi/getMbActiveById", params, header);
// };
// // 新增兑换信息
// export const addMbActiveTrade = (params, header) => {
//   return post(
//     http + "member.api/mbActiveTradeApi/addMbActiveTrade",
//     params,
//     header
//   );
// };
// 消息列表 商业H5
export const getH5MsgByUserId = (params, header) => {
  return post(http + "servers.api/messageApi/getH5MsgByUserId", params, header);
};
// 消息列表
export const getMsgByUserId = (params, header) => {
  return post(http + "servers.api/messageApi/getMsgByUserId", params, header);
};
// 我的订单列表
export const getActOrderListByUserId = (params, header) => {
  return post(
    http + "servers.api/activeRegistrationApi/getActOrderListByUserId",
    params,
    header
  );
};
// 查看消息个数
export const getMsgCount = (params, header) => {
  return post(http + "servers.api//messageApi/getMsgCount", params, header);
};
// 标记为已读
export const getMsgDetailById = (params, header) => {
  return post(http + "servers.api/messageApi/getMsgDetailById", params, header);
};
// 消息全部已读
export const batchReadMsg = (params, header) => {
  return post(http + "servers.api/messageApi/batchReadMsg", params, header);
};
// 我的卡券 获取二维码
export const transformToBase64 = (params, come) => {
  return postEwm(
    http + "servers.api/activeApi/transformToBase64",
    params,
    come
  );
};
// 取消订单
export const cancelOrderByOrderId = (params, header) => {
  return post(
    http + "servers.api/activeRegistrationApi/cancelOrderByOrderId",
    params,
    header
  );
};
// 订单退款
export const getOrderRefundRequest = (params, header) => {
  return post(
    http + "servers.api/activePayApi/getOrderRefundRequest",
    params,
    header
  );
};
// 首页可视化配置
export const getIndexStyleByMarketId = (params, header) => {
  return post(
    http + "servers.api/wapServerButtonApi/getIndexStyleByMarketId",
    params,
    header
  );
};
// 获取评分列表
export const getEvaluateList = (params, header) => {
  return post(http + "servers.api/evaluateApi/getEvaluateList", params, header);
};
// 根据id获取评价类型数据
export const getEvaluateTaskId = (params, header) => {
  return post(http + "servers.api/evaluateApi/getEvaluateTaskId", params, header);
};
// 活动评价
export const saveEvaluate = (params, header) => {
  return post(http + "servers.api/evaluateApi/saveEvaluate", params, header);
};
// 查看评价
export const getEvaluateDetail = (params, header) => {
  return post(
    http + "servers.api/evaluateApi/getEvaluateDetail",
    params,
    header
  );
};
// 生成支付订单
export const getActivePayOrder = (params, header) => {
  return post(
    http + "servers.api/activePayApi/getActivePayOrder",
    params,
    header
  );
};
// 获取公众号appid
export const getAppId = (params, header) => {
  return post(http + "servers.api/wxLoginApi/getAppId", params, header);
};
// 根据cityid业主获取项目列表
export const getMarketList = (params, header) => {
  return post(http + "servers.api/homeApi/getMarketList", params, header);
};
// 上传图片
export const uploadFile = (params, header) => {
  return post(http + "servers.api/fileApi/uploadFile", params, header);
};
// 上传图片-微信sdk
export const uploadWapFile = (params, header) => {
  return post(http + "servers.api/fileApi/uploadWapFile", params, header);
};
// 上传人脸图片-微信sdk
export const uploadWapFace = (params, header) => {
  return post(http + 'servers.api/fileApi/uploadWapFace', params, header)
}
// 会员权益
export const getdictionaryByType = (params, header) => {
  return post(
    http + "servers.api/dictionaryApi/getDictionaryByType",
    params,
    header
  );
};
// 个人信息 更新
export const updateUserInfo = (params, header) => {
  return post(http + "servers.api/usersApi/updateUserInfo", params, header);
};
// 统计
export const statistics = (params, header) => {
  return post(http + "servers.api/buryingPoint/add", params, header);
};
// 删除订单
export const delBondOrder = (params, header) => {
  return post(
    http + "member.api/mbBondActiveShopApi/delBondOrder",
    params,
    header
  );
};
// 取消订单
export const cancelBondOrder = (params, header) => {
  return post(
    http + "member.api/mbBondActiveShopApi/cancelBondOrder",
    params,
    header
  );
};
// 退出登录
export const unbindingUser = (params, header) => {
  return post(http + "servers.api/wxLoginApi/unbindingUser", params, header);
};
//电子发票
// 检查是否开通
export const checkInvoice = (params, header) => {
  return post(http + "servers.api/receiptApi/checkInvoice", params, header);
};

//检查开票类型是否开通
export const checkOpenReceipt = (params, header) => {
  return post(http + "servers.api/receiptApi/checkOpenReceipt", params, header);
};
//获取未开票订单
export const getNoReceiptList = (params, header) => {
  return post(http + "servers.api/receiptApi/getNoReceiptList", params, header);
};

//提交开票申请
export const InvoicingaddReceipt = (params, header) => {
  return post(http + "servers.api/receiptApi/addReceipt", params, header);
};


//开票历史
export const getReceiptList = (params, header) => {
  return post(http + "servers.api/receiptApi/getReceiptList", params, header);
};
//开票详情
export const getReceiptDetail = (params, header) => {
  return post(http + "servers.api/receiptApi/getReceiptDetail", params, header);
};
//税号查询
export const ReceiptApiSearchByName = (params, header) => {
  return post(http + "servers.api/receiptApi/searchByName", params, header);
};
//重发电子邮件
export const repeatReceipt = (params, header) => {
  return post(http + "servers.api/receiptApi/repeatReceipt", params, header);
};

//租户已认证列表接口
export const getUserTenantListByUserId = (params, header) => {
  return post(
    http + "servers.api/usersApi/getUserTenantListByUserId",
    params,
    header
  );
};

// Des加密
export const desEncrypt = (params, header) => {
  return post(
    http + "servers.api/qrCodeEncryptApi/desEncrypt",
    params,
    header
  );
};

//解除、删除认证
export const cancelUserTenant = (params, header) => {
  return post(http + "servers.api/usersApi/cancelUserTenant", params, header);
};
//id为设置默认认证信息的编号 跟新企业认证信息
export const updateUserTenant = (params, header) => {
  return post(http + "servers.api/usersApi/updateUserTenant", params, header);
};

//获取用户门禁照片
export const getUserInfofaceImgUrl = (params, header) => {
         return post(http + "servers.api/usersApi/getUserInfo", params, header);
       };

//上传 用户门禁照片
export const fileApiuploadFace = (params, header) => {
  return post(http + "servers.api/fileApi/uploadFace", params, header);
};

//上传 保存用户照片
export const saveUserFace = (params, header) => {
  return post(http + "servers.api/usersFaceApi/saveUserFace", params, header);
};

//招商信息
export const getParkInfo = (params, header) => {
  return post(http + "servers.api/homeApi/getParkInfo", params, header);
};
//招商园区团队
export const getParkMember = (params, header) => {
  return post(http + "servers.api/homeApi/getParkMember", params, header);
};
//商铺列表
export const getShopsByMarketId = (params, header) => {
  return post(http + "servers.api/shopsApi/getShopsByMarketId", params, header);
};

//商铺详情
export const getShopsInfo = (params, header) => {
  return post(http + "servers.api/shopsApi/getShopsInfo", params, header);
};

//数据字典 商铺分类
export const getSystemDistList = (params, header) => {
  return post(http + "servers.api/homeApi/getSystemDistList", params, header);
};
//领券中心列表
export const getMbBondActiveList = (params, header) => {
  return post(
    memberhttp + "member.api/mbBondApi/getMbBondActiveList",
    params,
    header
  );
};
//领券
export const addMbBond = (params, header) => {
         return post(
           memberhttp + "member.api/mbBondApi/addMbBond",
           params,
           header
         );
};
 // 遮照广告
export const getMaskingAds = (params, header) => {
  return post(
    memberhttp + "member.api/mbMaskingAdsApi/getMaskingAds",
    params,
    header
  );
};

//获取优惠券类型
export const getBondDict = (params, header) => {
      return post(
           memberhttp + "member.api/mbBondApi/getBondDict",
           params,
           header
      );
};
//获取优惠券列表
export const memberhttpgetMbBondListByUserId = (params, header) => {
         return post(
           memberhttp + "member.api/mbBondApi/getMbBondListByUserId",
           params,
           header
         );
       };

//优惠券详情
// export const getMbBondTemplateById = (params, header) => {
//          return post(
//            memberhttp + "member.api/mbBondApi/getMbBondActiveById",
//            params,
//            header
//          );
// };
// 个人中心 获取券活动名称
export const getMbBondActiveById = (params, header) => {
  return post(
    memberhttp + "member.api/mbBondApi/getMbBondActiveById",
    params,
    header
  );
}
// 我的卡券 详情
export const getMbBondTemplateById = (params, header) => {
  return post(
    memberhttp + "member.api/mbBondApi/getMbBondTemplateById",
    params,
    header
  );
};


//根据公司获取部门列表
export const getDeptByCompanyId = (params, header) => {
  return post(http + "servers.api/usersApi/getDeptByCompanyId", params, header);
};
//获取企业列表
export const queryCompanyTenant = (params, header) => {
  return post(
    http + "servers.api/visitorApi/queryCompanyTenant",
    params,
    header
  );
};
//受访人查询
export const queryExamineTenant = (params, header) => {
  return post(
    http + "servers.api/visitorApi/queryExamineTenant",
    params,
    header
  );
};
// 租户认证提交
export const userTenant = (params, header) => {
  return post(http + "servers.api/usersApi/userTenant", params, header);
};
// 获取商铺列表
export const getCompanyList = (params, header) => {
  return post(http + "servers.api/companyApi/getCompanyList", params, header);
};

// 园区公告列表
export const getNoticeListByMarketId = (params, header) => {
  return post(
    http + "servers.api/noticeApi/getNoticeListByMarketId",
    params,
    header
  );
};

// 园区公告详情
export const getNoticeDetailById = (params, header) => {
  return post(
    http + "servers.api/noticeApi/getNoticeDetailById",
    params,
    header
  );
};
//点赞
export const savePraise = (params, header) => {
  return post(http + "servers.api/userPraiseApi/savePraise", params, header);
};

//获取评论列表
export const getCommentList = (params, header) => {
  return post(
    http + "servers.api/userCommentApi/getCommentList",
    params,
    header
  );
};
//新增评论
export const saveComment = (params, header) => {
  return post(http + "servers.api/userCommentApi/saveComment", params, header);
};

//企业墙
export const getCompanyWallsByMarketId = (params, header) => {
  return post(
    http + "servers.api/companyWallApi/getCompanyWallsByMarketId",
    params,
    header
  );
};

//企业墙详情
export const getCompanyWallByMallIdAndCompanyId = (params, header) => {
  return post(
    http + "servers.api/companyWallApi/getCompanyWallByMallIdAndCompanyId",
    params,
    header
  );
};

// 在线账单
export const getOnlineBillingByParam = (params, header) => {
  return post(
    http + "servers.api/onlineBillingApi/getOnlineBillingByParam",
    params,
    header
  );
};

// 在线账单详情
export const geBillingDetailByParam = (params, header) => {
  return post(
    http + "servers.api/onlineBillingApi/geBillingDetailByParam",
    params,
    header
  );
};

// 获取账单关联发票信息接口
export const getInvoiceIssueDataByBillId = (params, header) => {
  return post(
    http + "servers.api/onlineBillingApi/getInvoiceIssueDataByBillId",
    params,
    header
  );
};



// 历史账单列表
export const geHistoryBillingByParam = (params, header) => {
  return post(
    http + "servers.api/onlineBillingApi/geHistoryBillingByParam",
    params,
    header
  );
};
// 会员积分
//积分商城 获取tab
export const getMbActiveGoodsTypeList = (params, header) => {
       return post(
         memberhttp + "member.api/mbActiveApi/getMbActiveGoodsTypeList",
         params,
         header
       );
};
////获取兑换活动列表
export const getMbActiveList = (params, header) => {
      return post(
        memberhttp + "member.api/mbActiveApi/getMbActiveList",
        params,
        header
      );
};
//根据兑换活动ID获取兑换活动详情
export const ysygetMbActiveById = (params, header) => {
         return post(
           memberhttp + "member.api/mbActiveApi/getMbActiveById",
           params,
           header
         );
};

//新增兑换信息
export const addMbActiveTrade = (params, header) => {
         return post(
           memberhttp + "member.api/mbActiveTradeApi/addMbActiveTrade",
           params,
           header
         );
};
//获取兑换记录列表
export const getMbActiveTradeListByUserId = (params, header) => {
         return post(
           memberhttp +
             "member.api/mbActiveTradeApi/getMbActiveTradeListByUserId",
           params,
           header
         );
       };
//获取我的积分列表
export const getMbUserIntegrationListByUserId = (params, header) => {
         return post(
           memberhttp +
             "member.api/mbUserIntegrationApi/getMbUserIntegrationListByUserId",
           params,
           header
         );
};
// 积分商城订单详情
export const getMbActiveTradeById = (params, header) => {
  return post(
    memberhttp + "member.api/mbActiveTradeApi/getMbActiveTradeById",
    params,
    header
  );
}

// 积分商城核销
export const verifiyTrade = (params, header) => {
  return post(
    memberhttp + "/member.api/mbActiveTradeApi/verifiyTrade",
    params,
    header
  );
}

export const getVerifiyTradeRecords = (params, header) => {
  return post(
    memberhttp + "/member.api/mbActiveTradeApi/getVerifiyTradeRecords",
    params,
    header
  );
}

// 取消订单
export const cancelTrade = (params, header) => {
  return post(
    memberhttp + "member.api/mbActiveTradeApi/cancelTrade",
    params,
    header
  );
}







// 个人中心获取等级
export const getUserByRelationId = (params, header) => {
  return post(
    memberhttp + "member.api/mbCenterApi/getUserByRelationId",
    params,
    header
  );
}


//创建账单预支付订单
export const insertAccountOrder = (params, header) => {
  return post(
    http + "servers.api/accountOrderApi/insertAccountOrder",
    params,
    header
  );
};


//获取企业认证列表
export const getUserTenantList = (params, header) => {
  return post(http + "servers.api/usersApi/getUserTenantList", params, header);
};
// 企业认证详情 根据认证id查看认证详情
export const getUserTenantDetail = (params, header) => {
  return post(
    http + "servers.api/usersApi/getUserTenantDetail",
    params,
    header
  );
};

//企业认证审批接口
export const enableUserTenant = (params, header) => {
  return post(http + "servers.api/usersApi/enableUserTenant", params, header);
};
// 授权列表
export const companyRoleList = (params, header) => {
  return post(http + 'servers.api/usersPermissionApi/companyRoleList', params, header)
}
// 被授权者授权列表
export const getRoleInfos = (params, header) => {
         return post(
           http + "servers.api/usersPermissionApi/getRoleInfos",
           params,
           header
         );
       };
// 授权
export const savePermission = (params, header) => {
  return post(http + 'servers.api/usersPermissionApi/savePermission', params, header)
}
//访客审批
export const updateVisitorStatus = (params, header) => {
  return post(
    http + "servers.api/visitorApi/updateVisitorStatus",
    params,
    header
  );
};
//会议室审批详情
export const getMeetingOrderDetailFromEnterpriseWeChat = (params, header) => {
  return post(
    http +
      "servers.api/meetingOrderApi/getMeetingOrderDetailFromEnterpriseWeChat",
    params,
    header
  );
};
//会议室审批支付
export const updateOrderStatusFromEnterpriseWeChat = (params, header) => {
  return post(
    http + "servers.api/meetingOrderApi/updateOrderStatusFromEnterpriseWeChat",
    params,
    header
  );
};

//获取拜访详情
export const getVisitorDetailById = (params, header) => {
  return post(
    http + "servers.api/visitorApi/getVisitorDetailById",
    params,
    header
  );
};

//新增访客
export const insertVisitorReg = (params, header) => {
  return post(http + "servers.api/visitorApi/insertVisitorReg", params, header);
};
//获取来访表信息
export const getVisitorRegByParams = (params, header) => {
  return post(
    http + "servers.api/visitorApi/getVisitorRegByParams",
    params,
    header
  );
};
//访客
export const getVisitorListByMarketId = (params, header) => {
  return post(
    http + "servers.api/visitorApi/getVisitorListByMarketId",
    params,
    header
  );
};
//取消
export const cancelVisitorById = (params, header) => {
  return post(
    http + "servers.api/visitorApi/cancelVisitorById",
    params,
    header
  );
};
//获取默认员工的楼栋信息
export const getTenantBuildList = (params, header) => {
  return post(
    http + "servers.api/visitorApi/getTenantBuildList",
    params,
    header
  );
};
//员工的门禁二维码
export const getTenantQrCode = (params, header) => {
         return post(
           http + "servers.api/visitorApi/getTenantQrCode",
           params,
           header
         );
       };

//会议室列表
export const getMeetingRoomListByUserId = (params, header) => {
  return post(
    http + "servers.api/meetingRoomApi/getMeetingRoomListByUserId",
    params,
    header
  );
};
//会议室详情
export const getMeetingRoomById = (params, header) => {
  return post(
    http + "servers.api/meetingRoomApi/getMeetingRoomById",
    params,
    header
  );
};
//根据参数获取当天的某会议室预售的时段列表
export const getMeetingPriceList = (params, header) => {
  return post(
    http + "servers.api/meetingPayApi/getMeetingPriceList",
    params,
    header
  );
};
//校验会议室预订时间
export const checkMeetingTime = (params, header) => {
  return post(
    http + "servers.api/meetingPayApi/checkMeetingTime",
    params,
    header
  );
};
//创建订单
export const insertMeetingOrder = (params, header) => {
  return post(
    http + "servers.api/meetingPayApi/insertMeetingOrder",
    params,
    header
  );
};
//会议室发送邮件接协议
export const meetingSendAgreementEmail = (params, header) => {
         return post(
           http + "servers.api/meetingRoomApi/sendAgreementEmail",
           params,
           header
         );
       };
//账单发票发送邮件接协议
export const sendInvoicePdfEmail = (params, header) => {
         return post(
           http + "servers.api/onlineBillingApi/sendInvoicePdfEmail",
           params,
           header
         );
       };
//更新订单的 开票信息
export const updateMeetingOrder = (params, header) => {
         return post(
           http + "servers.api/meetingPayApi/updateMeetingOrder",
           params,
           header
         );
       };
// 获取优惠券抵扣详情
export const getDeductRule = (params, header) => {
  return post(
    memberhttp + "member.api/mbIntegrationDeductApi/getDeductRule",
    params,
    header
  )
}
//获取优惠券列表
export const getMbBondListByUserId = (params, header) => {
  return post(
    http + "member.api/mbBondApi/getMbBondListByUserId",
    params,
    header
  );
};
//会议室订单列表
export const getMeetingOrderList = (params, header) => {
  return post(
    http + "servers.api/meetingOrderApi/getMeetingOrderList",
    params,
    header
  );
};
//会议室订单 详情
export const getMeetingOrderDetailById = (params, header) => {
  return post(
    http + "servers.api/meetingOrderApi/getMeetingOrderDetailById",
    params,
    header
  );
};
//会议室订单 取消订单
export const cancelMeetingOrder = (params, header) => {
  return post(
    http + "servers.api/meetingPayApi/cancelMeetingOrder",
    params,
    header
  );
};
export const repairSaveEvaluate = (params, header) => {
  return post(
    http + "ibp_app_api/propertyRepairApi/saveEvaluate",
    params,
    header
  );
};
//企业报表
export const getContractList = (params, header) => {
  return post(http + "servers.api/contractApi/getContractList", params, header);
};
export const getTenantReportByParam = (params, header) => {
  return post(
    http + "servers.api/billInfoApi/getTenantReportByParam",
    params,
    header
  );
};
//营收填报
// 营收填报列表
export const getRevenueList = (params, header) => {
  return post(http + "servers.api/revenueApi/getRevenueList", params, header);
};
//营收填报详情
export const getRevenueDetail = (params, header) => {
  return post(http + "servers.api/revenueApi/getRevenueById", params, header);
};
//保存营收填报
export const saveRevenue = (params, header) => {
  return post(http + "servers.api/revenueApi/saveRevenue", params, header);
};

//判断用户是否有模块权限
export const getPermissionByUserId = (params, header) => {
  return post(
    http + "servers.api/usersApi/getPermissionByUserId",
    params,
    header
  );
};
//公众号分享参数获取
export const getShareInfo = (params, header) => {
  return post(http + "servers.api/wxShareApi/getShareInfo", params, header);
};
// 水电充值 生成订单
export const insertRechargeOrder = (params, header) => {
  return post(
    http + "servers.api/activeRechargeApi/insertRechargeOrder",
    params,
    header
  );
};

//spaceUp转发接口
export const callSpaceUp = (params, header) => {
  return post(http + "servers.api/repairApi/call", params, header);
};
//空铺列表
export const getVacantShopByMarketId = (params, header) => {
  return post(
    http + "servers.api/vacantShopApi/getVacantShopByMarketId",
    params,
    header
  );
};
//空铺详情
export const getDetailById = (params, header) => {
  return post(http + "servers.api/vacantShopApi/getDetailById", params, header);
};
//获取报修房源
export const getStoreList = (params, header) => {
  return post(http + "servers.api/contractApi/getStoreList", params, header);
};

// /**
//  * 附件绑定到具体的业务数据
//  */
// export const bindSomeAttachments = (data) => {
//   return post('/syscfg/attachment/bindSomeAttachments', data)
// }

// 政策服务
export const getPolicyTypeByMarketId = (params, header) => {
  return post(
    http + "servers.api/policy/getPolicyTypeByMarketId",
    params,
    header
  );
};
export const getPolicyTypeByTypeCode = (params, header) => {
  return post(
    http + "servers.api/policy/getPolicyTypeByTypeCode",
    params,
    header
  );
};
export const getPolicyByTypeCode = (params, header) => {
  return post(http + "servers.api/policy/getPolicyByTypeCode", params, header);
};
export const gePolicyDetail = (params, header) => {
  return post(http + "servers.api/policy/gePolicyDetail", params, header);
};
export const saveAdvices = (params, header) => {
  return post(http + "servers.api/policy/saveAdvices", params, header);
};
export const getAdviceByUserId = (params, header) => {
  return post(http + "servers.api/policy/getAdviceByUserId", params, header);
};
export const getAdviceById = (params, header) => {
  return post(http + "servers.api/policy/getAdviceById", params, header);
};
//处理咨询
export const updateAdviceById = (params, header) => {
         return post(
           http + "servers.api/policy/updateAdviceById",
           params,
           header
         );
       };
export const setWapServerButtonByUser = (params, header) => {
  return post(
    http + "servers.api/wapServerButtonApi/setWapServerButtonByUser",
    params,
    header
  );
};
// 家政服务
// 1、服务模板详情
export const getIntServTemplateByMarketId = (params, header) => {
  return post(
    http + "servers.api/intServApi/getIntServTemplateByMarketId",
    params,
    header
  );
};
// 服务类型
export const getIntServTemplateById = (params, header) => {
  return post(
    http + "servers.api/intServApi/getIntServTemplateById",
    params,
    header
  );
};
// 2、生成预约单
export const saveIntServOrder = (params, header) => {
  return post(http + "servers.api/intServApi/saveIntServOrder", params, header);
};
// 3、修改预约单
export const updateIntServOrder = (params, header) => {
  return post(
    http + "servers.api/intServApi/updateIntServOrder",
    params,
    header
  );
};
// 4.我的预约单/根据受理人查预约单
export const getIntServOrderList = (params, header) => {
  return post(
    http + "servers.api/intServApi/getIntServOrderList",
    params,
    header
  );
};
// 5、预约单详情
export const getIntServOrderByOrderId = (params, header) => {
  return post(
    http + "servers.api/intServApi/getIntServOrderByOrderId",
    params,
    header
  );
};
// 6、受理人列表
export const getIntServWorkerList = (params, header) => {
  return post(
    http + "servers.api/intServApi/getIntServWorkerList",
    params,
    header
  );
};
// 7、服务类型字典
export const getServiceTypeDict = (params, header) => {
  return post(
    http + "servers.api/intServApi/getServiceTypeDict",
    params,
    header
  );
};
// 隐私政策
export const findPrivacyByMarketId = (params, header) => {
  return post(
    http + "servers.api/servicePrivacy/findPrivacyByMarketId",
    params,
    header
  );
};
// 服务协议
export const findServiceByMarketId = (params, header) => {
  return post(
    http + "servers.api/servicePrivacy/findServiceByMarketId",
    params,
    header
  );
};

// 办公耗材

// 1、办公耗材列表
export const getOfficeMaterialListByMarketId = (params, header) => {
  return post(
    http + "servers.api/officeMaterialApi/getOfficeMaterialListByMarketId",
    params,
    header
  );
};
// 2、办公耗材详情
export const getOfficeMaterialById = (params, header) => {
  return post(
    http + "servers.api/officeMaterialApi/getOfficeMaterialById",
    params,
    header
  );
};
// 3、办公耗材订单列表
export const getOfficeMaterialOrderList = (params, header) => {
  return post(
    http + "servers.api/officeMaterialApi/getOfficeMaterialOrderList",
    params,
    header
  );
};
// 4、获取办公耗材订单详情
export const getOfficeMaterialOrderDetailById = (params, header) => {
  return post(
    http + "servers.api/officeMaterialApi/getOfficeMaterialOrderDetailById",
    params,
    header
  );
};
// 5、生成送货单
export const saveDelivery = (params, header) => {
  return post(
    http + "servers.api/officeMaterialApi/saveDelivery",
    params,
    header
  );
};
// 6、修改送货单
export const updateDelivery = (params, header) => {
  return post(
    http + "servers.api/officeMaterialApi/updateDelivery",
    params,
    header
  );
};
// 7、创建订单
export const saveOfficeMaterialOrder = (params, header) => {
  return post(
    http + "servers.api/officeMaterialApi/saveOfficeMaterialOrder",
    params,
    header
  );
};
// 8、企业微信修改订单状态
export const officeupdateOrderStatusWeChat = (params, header) => {
  return post(
    http + "servers.api/officeMaterialApi/updateOrderStatusFromEnterpriseWeChat",
    params,
    header
  );
};
// 9、送货人列表
export const getDeliveryWorkers = (params, header) => {
  return post(
    http + "servers.api/officeMaterialApi/getDeliveryWorkers",
    params,
    header
  );
};


// 停车管理
//1. 获取停车场详情信息
export const loadParkHeaderById = (params, header) => {
  return post(
    http + "servers.api/repairApi/call",
    params,
    header
  );
};
//停车模块接口  无需登录
export const freeCall = (params,header) => {
  return post(http + "servers.api/repairApi/freeCall",params,
  header)
}
// 3.取消支付
export const removeRequestOrder = (params, header) => {
  return post(http + "servers.api/requestOrderApi/removeRequestOrder",params,header);
};
// 4.审批流
export const queryBpmFlowByBuildIds = (params, header) => {
  return fetch("get",spaceUpPcHttp + "/syscfg/bpmSyscfg/queryBpmFlowByBuildIds",params,header);
};
export const startInstance = (params, header) => {
  return fetchPost('post',spaceUpPcHttp + "/bpmsmart/workFlowInstance/startInstance",params,header);
};
//1. checkEvaluateButton 是否展示去评价 按钮
export const checkEvaluateButton = (params, header) => {
  return post(
    http + "servers.api/evaluateApi/checkEvaluateButton",
    params,
    header
  );
};
//核销疫情扫一扫核销
export const writeOff = (params, header) => {
  return post(memberhttp + "member.api/esApi/writeOff",params,header);
};
// 智慧办公
// 会议室列表
export const getMeetingRoomList = (params, header) => {
  return post(http + "servers.api/meetingApi/getMeetingRoomList",params,header);
};
// 获取会议室可订列表
export const getMeetingBookList = (params, header) => {
  return post(http + "servers.api/meetingApi/getMeetingBookList",params,header);
};
// 创建订单
export const insertMeetingOrderSmart = (params, header) => {
  return post(http + "servers.api/meetingApi/insertMeetingOrder",params,header);
};
// 获取订单列表
export const getMeetingOrderListSmart = (params, header) => {
  return post(http + "servers.api/meetingApi/getMeetingOrderList",params,header);
};
// 根据公司名称模糊查询纳税人识别号
export const receiptApisearchByName = (params, header) => {
         return post(
           http + "servers.api/receiptApi/searchByName",
           params,
           header
         );
       };
//获取公司会议室的订单
// meetingApi / getMeetingOrderlistByRoomNo;
export const getMeetingOrderListByRoomNo = (params, header) => {
         return post(
           http + "servers.api/meetingApi/getMeetingOrderListByRoomNo",
           params,
           header
         );
       };

       //获取项目会议室的订单
// meetingApi / getMeetingOrderlistByRoomNo;
export const getMarketMeetingOrderListByRoomNo = (params, header) => {
         return post(
           http +
             "servers.api/meetingOrderApi/getMeetingOrderListByRoomNo",
           params,
           header
         );
       };


//奋斗报告
//团队报告
export const teamReport = (params, header) => {
         return post(
           http + "servers.api/signinApi/teamReport",
           params,
           header
         );
       };
//部门列表
export const orgApiList = (params, header) => {
         return post(http + "servers.api/orgApi/list", params, header);
       };
//日历报告
export const calendarReport = (params, header) => {
  return post(http + "servers.api/signinApi/calendarReport",params,header);
};
//月报报告
export const getmonthReport = (params, header) => {
         return post(
           http + "servers.api/signinApi/monthReport",
           params,
           header
         );
       };
// 获取订单详情
export const getMeetingOrderDetailByIdSmart = (params, header) => {
  return post(http + "servers.api/meetingApi/getMeetingOrderDetailById",params,header);
};
// 获取会议室详情
export const getMeetingRoomDetailByIdSmart = (params, header) => {
  return post(http + "servers.api/meetingApi/getMeetingRoomDetailById",params,header);
};
// 取消订单
export const cancelMeetingOrderSmart = (params, header) => {
  return post(http + "servers.api/meetingApi/cancelMeetingOrder",params,header);
};